<template>
  <UpsellItemBase
    :title="`${upsell.product.name} ${upsell.title}`"
    :price="price"
    :show-image-swatch="upsell.product.lensChoice"
    :sku="upsell.product.sku"
    :selected="upsell.isInCart"
    :cart-externally-updating="cartUpdating"
    :upsell="upsell"
    :static-img="{
      path: '/images/upsells/polarised-lens-comparison-view.jpg',
      alt: 'Polarised vs non polarised view of road',
      title: 'Polarised vs non polarised',
    }"
    :index="index"
    @add-to-cart="addToCart"
    @remove-from-cart="downgrade"
  />
</template>

<script>
import { buildCartItems } from '~/assets/js/helpers/shopify'

export default {
  name: 'UpsellItemLensType',

  props: {
    upsell: { type: Object, required: true },
    index: {type: Number, default: 0}
  },

  setup () {
    const shopifyStore = useShopifyStore()

    return { shopifyStore }
  },

  data() {
    return {
      cartUpdating: false,
    }
  },

  computed: {
    price () {
      if (!this.lineItemToRemove) {
        if (this.polarisationDowngrade) {
          return this.upsell.polarisationUpsell.amount_float
        }

        return this.upsell.polarisationUpsell.priceDifference
      }

      if (this.polarisationDowngrade.priceDifference !== 0) {
        return (
          (this.upsell.polarisationUpsell.amount_float -
            this.polarisationDowngrade.amount_float) *
          this.lineItemToRemove.summary.bundleQuantity
        )
      }

      return (
        this.upsell.polarisationUpsell.priceDifference *
        this.lineItemToRemove.summary.bundleQuantity
      )
    },

    lineItemToRemove() {
      return Object.values(this.shopifyStore.bundledCartItems).filter(bundledCartItem => {
        return bundledCartItem.summary.bundleSku === this.upsell.sku &&
        !bundledCartItem.summary.bundleSku.includes(this.upsell.polarisationUpsell.sku)
      })[0]
    },

    polarisationDowngrade() {
      return this.upsell.product.lensTypeOptions.filter(
        (lensTypeOption) => {
          return lensTypeOption.amount_float < this.upsell.polarisationUpsell.amount_float
        }
      )[0]
    },
  },

  methods: {
    downgrade() {
      /**
       *
       * Here we reverse the upsell that was previously applied.
       *
       * 1. Get lower cost lensTypeOption from those available on the product
       * 2. Set product to have the full downgraded sku
       * 3. Call addToCart() to add the downgraded option to cart and remove the previous upsold one
       *
       *  */
      if (!this.polarisationDowngrade) return

      this.upsell.product.setChoice(this.polarisationDowngrade.sku)

      this.addToCart(this.polarisationDowngrade.sku)
    },

    async removeFromCart() {
      if (!this.lineItemToRemove) return

      try {
        await this.shopifyStore.removeCartItems([ this.lineItemToRemove.summary.bundleSku ])
      } catch (error) {
        this.$sentry.captureException(error)
        console.log(error)
      }

      this.cartUpdating = false
    },

    async addToCart(skuToUpsell) {
      this.cartUpdating = true

      try {
        // update customised product to have the polarised sku
        this.upsell.product.setChoice(
          skuToUpsell || this.upsell.polarisationUpsell.sku
        )

        const builtCartItems = buildCartItems(this.upsell.product)
        await this.shopifyStore.addCartItems(builtCartItems)

        this.$track.product.add(this.upsell.product, {
          location: 'cart-polarisation-upsell',
          quantity: this.lineItemToRemove.quantity,
        })

        this.removeFromCart()
      } catch (error) {
        this.$sentry.captureException(error)
        console.log(error)
      }

      this.cartUpdating = false
    },
  },
}
</script>
